/* eslint-disable @typescript-eslint/no-use-before-define */
import { useMemo } from 'react';
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';

import { SPACING } from '../design-system/RunningText';

const Wrapper = styled.div<{ $stretch: boolean }>`
  display: flex;
  margin-bottom: ${SPACING}px;

  ${({ $stretch }) => $stretch && `margin: 0 -12vw;`}
`;

const VidWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;

  &:last-child {
    margin-right: 0;
  }

  video {
    width: 100%;
    height: auto;
  }
`;

interface InlineVideoProps {
  caption: string;
  name?: string;
  src?: string;
  stretch?: boolean;
}

export const InlineVideo: React.ComponentType<InlineVideoProps> = React.memo(
  ({ caption, name, stretch = false, src }) => {
    const data = useStaticQuery(pageQuery);

    const videoPath = useMemo(() => {
      const allVideos = [...data.allContentfulAsset.edges];
      return allVideos.filter(video => video.node.title === name);
    }, [data.allContentfulAsset.edges, name]);

    return (
      <Wrapper $stretch={stretch}>
        <figure>
          <VidWrapper>
            <video
              autoPlay={true}
              controls={false}
              loop={true}
              muted={true}
              playsInline={true}
              preload="auto"
              // render inline video from markdown OR rich text
              src={src || videoPath[0].node.url}
              webkit-playsinline=""
              x5-playsinline=""></video>
          </VidWrapper>
          <figcaption>{caption}</figcaption>
        </figure>
      </Wrapper>
    );
  }
);

const pageQuery = graphql`
  query {
    allContentfulAsset(
      filter: { mimeType: { in: ["video/quicktime", "video/mp4"] } }
    ) {
      edges {
        node {
          title
          url
        }
      }
    }
  }
`;
